export default __webpack_public_path__ + "static/media/5f.1f7a9413.png";